import { CodeHighlight } from "@mantine/code-highlight";
import { Tabs } from "@mantine/core";

import type { CodeTab } from "../../config";

interface CodeGroupProps {
  tabs?: CodeTab[];
}

/**
 * CodeGroup renders the {% code-group %} tag as Mantine `Tabs`: one tab per
 * code block, each panel a highlighted `CodeHighlight` with a copy button.
 */
export const CodeGroup = ({ tabs = [] }: CodeGroupProps) => {
  const [firstTab] = tabs;

  if (!firstTab) {
    return null;
  }

  return (
    <Tabs defaultValue={firstTab.value} my="md" variant="outline">
      <Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Panel key={tab.value} value={tab.value}>
          <CodeHighlight code={tab.content} language={tab.language} withCopyButton />
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};
